import { Injectable, ErrorHandler } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { LoggerService } from "../logging/logging.service";
import { LoggerDTO } from "src/app/models/logging/LoggerDTO";
import { NGXLogger } from "ngx-logger";
import { environment } from "../../../../environments/environment";

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  errorResponse: LoggerDTO = new Object();
  envName: string = (<any>environment).envName;
  api: string = environment.apiGatewayUrl;

  constructor(private logger: LoggerService, private _log: NGXLogger) {}
  handleError(error: any) {
    this.logError(error);
  }

  logError(error: any) {
    //Returns a date converted to a string using Universal Coordinated Time (UTC).

    if (error instanceof HttpErrorResponse) {
      //The response body may contain clues as to what went wrong,
      this.errorResponse.onwer = "BE";
      this.errorResponse.errorCode = (<HttpErrorResponse>error).status;
      this.errorResponse.errorMessage = error.message;
      this.errorResponse.url = `${(<HttpErrorResponse>error).url} - ${
        (<HttpErrorResponse>error).name
      }`;
      this.errorResponse.timestamp = new Date();
    } else if (error instanceof TypeError) {
      //Client side error in typescript
      this.errorResponse.onwer = "FE";
      this.errorResponse.errorMessage = `${(<TypeError>error).name} -  ${
        (<TypeError>error).message
      } [${(<TypeError>error).stack}]`;
      this.errorResponse.timestamp = new Date();
    } else if (error instanceof Error) {
      //Generic CLient side error
      this.errorResponse.onwer = "FE";
      this.errorResponse.errorMessage = `${(<Error>error).name} - ${
        (<Error>error).message
      } [${(<Error>error).stack}]`;
      this.errorResponse.timestamp = new Date();
    } else if (error instanceof ErrorEvent) {
      //A client-side or network error occurred. Handle it accordingly.
      this.errorResponse.onwer = "FE";
      this.errorResponse.errorMessage = `${(<ErrorEvent>error).error} - ${
        (<ErrorEvent>error).message
      } `;
      this.errorResponse.timestamp = new Date();
    } else {
      this.errorResponse.onwer = "FE";
      this.errorResponse.errorMessage = `Something went wrong: ${error.message} - ${error.stack} `;
      this.errorResponse.timestamp = new Date();
    }

    if (this.envName === "dev") {
      this._log.trace(error);
    }
    if (this.envName === "qa") {
      this._log.info(this.errorResponse);
    }
    if (this.envName === "prod") {
      this._log.warn(this.errorResponse);
    }
  }
}
